module.exports = __webpack_public_path__ + "static/media/desktop_background_main.a316be34.png";